import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const IMG = 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/ieuntttw_1.JPG';

export default function LiveEventsTeaser() {
  return (
    <section className="px-6 py-20" data-testid="live-events-teaser">
      <div className="max-w-[1400px] mx-auto grid md:grid-cols-12 gap-0 rounded-2xl overflow-hidden border border-white/10">
        <div className="md:col-span-5 aspect-[4/3] md:aspect-auto">
          <img src={IMG} alt="Live merch printing at an event" loading="lazy" className="w-full h-full object-cover" />
        </div>
        <div className="md:col-span-7 p-10 md:p-16 flex flex-col justify-center bg-white/[0.02]">
          <p className="text-xs uppercase tracking-[0.25em] text-[#00b8ff] mb-4">Also available</p>
          <h2 className="font-display text-[#f4efe6] uppercase text-4xl md:text-6xl tracking-tight leading-[0.95]">
            Live Event <span className="font-script text-[#00b8ff] normal-case italic">Printing</span>
          </h2>
          <p className="text-[#cfc8bb] text-base md:text-lg mt-6 max-w-xl leading-relaxed">
            Live printing and fully managed merch booths for festivals, brand activations and corporate events.
          </p>
          <Link to="/live-events" className="group inline-flex items-center gap-2 mt-8 self-start text-[#f4efe6] font-semibold border-b border-[#00b8ff] pb-1 hover:text-[#00b8ff] transition-colors duration-200" data-testid="live-events-teaser-link">
            Explore Live Events <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>
  );
}
